import {
  ChallengeShell,
  ChoiceGrid,
  useChoices,
  usePickHandler,
  type ChallengeProps,
} from "./shared";

/** See a picture, pick the matching English word. */
export function ImageToWord({ word, distractors, onAnswer }: ChallengeProps) {
  const choices = useChoices(word, distractors);
  const { picked, handle, teachOverlay } = usePickHandler(word, onAnswer);

  return (
    <>
      <ChallengeShell
        tag="Picture word"
        imageUrl={word.imageUrl}
        prompt="What is this in English?"
        speakerText={word.english}
        speakerAudioUrl={word.audioUrl}
      >
        <ChoiceGrid
          choices={choices}
          correctId={word.id}
          picked={picked}
          onPick={handle}
          render={(c) => <span className="choice-vi">{c.english}</span>}
        />
      </ChallengeShell>
      {teachOverlay}
    </>
  );
}
